<mat-card-title class="h5">
	Parent/Guardian Information
</mat-card-title>
<mat-divider> </mat-divider>

<div *ngIf="parents && parents.length > 0" class="margin-top-md">
	<mat-table [dataSource]="tableDataSources[0]" class="table-responsive mat-elevation-z1" matSort>
		<form [formGroup]="editingForm">
			<ng-container matColumnDef="EDIT">
				<mat-header-cell *matHeaderCellDef> </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<div *ngIf="element.ID !== editingId">
						<button mat-icon-button color="primary" (click)="editParent(element)" matTooltip="Edit">
							<mat-icon>edit</mat-icon>
						</button>
					</div>
					<div *ngIf="element.ID === editingId">
						<confirm-popover [buttonType]="'mini-icon'" [icon]="'check'" [color]="'primary'"
							[popoverMsg]="'Confirm Parent Edit'" [popoverConfirmText]="'Confirm'"
							[popoverConfirmColor]="'primary'" [tooltip]="'Update'" (onConfirm)="confirmEditParent()"
							[disabled]="!editingForm.valid">
						</confirm-popover>

						<confirm-popover [buttonType]="'mini-icon'" [icon]="'close'" [color]="'warn'"
							[popoverMsg]="'Cancel?'" [popoverConfirmText]="'Yes'" [popoverCancelText]="'No'"
							[popoverConfirmColor]="'primary'" [tooltip]="'Cancel'" (onConfirm)="cancelEditParent()">
						</confirm-popover>
					</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="COE_PEOPLE_TYPE.TYPE">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Type </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<div>
						{{element.COE_PEOPLE_TYPE.TYPE}}
					</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="LAST_NAME">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Last Name </mat-header-cell>
				<mat-cell *matCellDef="let element" class="row">
					<div *ngIf="element.ID !== editingId">
						{{element.LAST_NAME}}
					</div>
					<div *ngIf="element.ID === editingId" class="col">
						<div class="row">
							<mat-form-field class="mat-form-field-padding">
								<mat-label>
									Last Name
								</mat-label>
								<input matInput type="string" placeholder="Last Name" formControlName="lastName" />
							</mat-form-field>
						</div>
					</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="FIRST_NAME">
				<mat-header-cell *matHeaderCellDef mat-sort-header> First Name </mat-header-cell>
				<mat-cell *matCellDef="let element" class="row">
					<div *ngIf="element.ID !== editingId">
						{{element.FIRST_NAME}}
					</div>
					<div *ngIf="element.ID === editingId" class="col">
						<div class="row">
							<mat-form-field class="mat-form-field-padding">
								<mat-label>
									First Name
								</mat-label>
								<input matInput type="string" placeholder="First Name" formControlName="firstName" />
							</mat-form-field>
						</div>
					</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="PHONE_NUMBER">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Preferred Phone Number </mat-header-cell>
				<mat-cell *matCellDef="let element" class="row">
					<div *ngIf="element.ID !== editingId">
						{{element.PHONE_NUMBER}}
					</div>
					<div *ngIf="element.ID === editingId" class="col">
						<div class="row">
							<mat-form-field class="mat-form-field-padding">
								<mat-label>
									Preferred Phone Number
								</mat-label>
								<input matInput type="string" placeholder="Preferred Phone Number"
									formControlName="preferredPhoneNumber" telephoneValidator />
							</mat-form-field>
						</div>
					</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="EMAIL_ADDRESS">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Preferred Email </mat-header-cell>
				<mat-cell *matCellDef="let element" class="row">
					<div *ngIf="element.ID !== editingId">
						{{element.EMAIL_ADDRESS}}
					</div>
					<div *ngIf="element.ID === editingId" class="col">
						<div class="row">
							<mat-form-field class="mat-form-field-padding">
								<mat-label>
									Preferred Email
								</mat-label>
								<input matInput type="string" placeholder="Preferred Email"
									formControlName="preferredEmail" />
							</mat-form-field>
						</div>
					</div>
				</mat-cell>
			</ng-container>
		</form>

		<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
		<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
	</mat-table>

</div>

<tracking-history class="margin-horizontal-md" *ngIf="parentIds.length > 0 && !isLoading"
	[formName]="'Parent Information'" [formID]="parentIds"></tracking-history>